/* eslint-disable react/iframe-missing-sandbox */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable prefer-destructuring */
/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-duplicate-imports */
import {
  Box,
  Grid,
  Dialog,
  IconButton,
  Typography,
  DialogActions,
  DialogContent,
  FormHelperText,
  Autocomplete
} from '@mui/material';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { UiSelect, UiSwitch } from '../../../../../components/ui/atoms';
import { Controller, FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { API } from '../../../../../api';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useProgramContext } from '../../../../../hooks/useProgramContext';
import { articleActions, fetchAllArticles } from '../../../../../redux/slices/article/getAllArticleSlice';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { AtomicBlockUtils, ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { ImageBlock } from '../../Program/components/program tabs/settings components/LessonDescriptionEditor';
import { Close } from '@mui/icons-material';
import { FileOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { safeEditorStateFromHtml } from '../../../../../utils/draftHtml';
import { handleImageCompression } from '../../../components/common';
import ROLES from '../../../../../utils/roles';
import { getUserDetails } from '../../../../../utils/orgName';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';
import DosenInput from '../../../components/DosenInput';

const acceptedImages = 'image/jpeg,image/jpg,image/png';

// Allowed document types for the "Text" article upload (PDF, Word, Excel, CSV, plain text)
const ALLOWED_TEXT_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt'];
interface Props {
  openForm: boolean;
  handleClickCloseForm: any;
  setOpenForm: any;
  selectedActiveId: any;
  singleListData: any;
  action: any;
  setAction: any;
  onNewArticleCreated?: any;
  newGroupId?: string
}

// Author Name, Accessible To and the cover image were removed from the form:
// the author defaults to the org name, access defaults to All and the cover
// image defaults to the org logo (applied server-side on create).
const schema = yup.object().shape({
  articleName: yup.string().required('Resource name is required'),
  type: yup.string().required('Resource type is required'),
  readTime: yup.string().required('Read time is required'),
  articleViewableTo: yup.string().required('Who can view is required'),
  topic: yup.string().optional(),
  articleDescription: yup.string().required('Resource description is required')
});
const toolBarStyle = {
  border: 'none',
  backgroundColor: '#1C1C1C',
  padding: '10px 0',
  marginBottom: 0,
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px'
};

const AddEditContent: FC<Props> = ({
  openForm,
  handleClickCloseForm,
  setOpenForm,
  selectedActiveId,
  singleListData,
  action,
  onNewArticleCreated,
  newGroupId
}: Props) => {
  const dispatch = useAppDispatch();
  const { groupId: grpId, orgId, coId, location: resolvedLocation, isPlatformAdmin } = useProgramContext();
  const resolvedGroupId = React.useMemo(() => {
    const baseGroupId = grpId && grpId !== 'admin' ? grpId : coId;
    console.log({newGroupId, baseGroupId})
    return newGroupId || baseGroupId;
  }, [grpId, coId, newGroupId]);
  const manualBuilderGroupId = useAppSelector((state) => state.orgDetails.data?.grpId);
  // Defaults applied on save: the org name stands in for the removed Author
  // Name field (getUserDetails().orgName covers a not-yet-loaded org store).
  const orgName = useAppSelector((state) => state.orgDetails.data?.name);
  const [addEditSubmitLoader, setAddEditSubmitLoader] = useState(false);
  const [isPublished, setIsPublished] = useState(true);
  const [videoFile, setVideoFile] = useState<File | null>(null);
  const [audioFile, setAudioFile] = useState<File | null>(null);
  const [textFile, setTextFile] = useState<any>(null);
  const [textFileUrl, setTextFileUrl] = useState<any>(null);
  const [urlName, setUrlName] = useState('');
  const [textFileError, setTextFileError] = useState<string | null>(null);
  const [type, setType] = useState('Text');
  const [readTimeValue, setReadTimeValue] = useState('');

  const [viewFor, setViewFor] = useState('');
  const [editCoverImg, setEditCoverImg] = useState<string>();
  const [editVideoUrl, setEditVideoUrl] = useState<File | null>(null);
  const [videoError, setVideoError] = useState<string | null>(null);
  const [editAudioUrl, setEditAudioUrl] = useState<File | null>(null);
  const [audioError, setAudioError] = useState<string | null>(null);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const blobTextFileUrl = textFile ? URL.createObjectURL(textFile) : null;

  const TagList = ['General', 'Product Tutorials', 'Case Studies', 'Testimonials', 'Program Materials'];

  const groupData = useAppSelector((state) => state.groupDetails);

  const checkError = (fieldName: string) => Boolean(errors[fieldName]);
  const getError = (fieldName: string) => errors[fieldName]?.message;

  useEffect(() => {
    setType('');
    setReadTimeValue('');
    setViewFor('');
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    getValues,
    reset,
    watch
  } = useForm({
    resolver: yupResolver(schema)
  });

  const safeUrlName = urlName || '';
  // Keep the full original file name (including its extension); only strip the
  // storage timestamp prefix (e.g. "1712345678901_") and decode URL escapes.
  let filename = safeUrlName.substring(safeUrlName.lastIndexOf('/') + 1);
  filename = filename.replace(/^\d+_/, '');
  try {
    filename = decodeURIComponent(filename);
  } catch {
    filename = filename.replace(/%20/g, ' ');
  }

  const watchArticleType = watch('type');

  const onSubmit: SubmitHandler<FieldValues> = async (value) => {
    setAddEditSubmitLoader(true);
    const formData = new FormData();
    formData.append('articleName', value.articleName);
    formData.append('type', value.type);
    // Author Name is no longer collected — every resource is authored by the org.
    formData.append('authorName', value.authorName || orgName || getUserDetails().orgName || 'Author');

    formData.append('readTime', value.readTime);
    formData.append('articleDescription', value.articleDescription);
    const articleViewableTo = Array.isArray(value.articleViewableTo)
      ? value.articleViewableTo
      : value.articleViewableTo
      ? [value.articleViewableTo]
      : [];
    const articleViewableToPayload =
      articleViewableTo.length <= 1 ? articleViewableTo[0] || '' : JSON.stringify(articleViewableTo);
    formData.append('articleViewableTo', articleViewableToPayload);

    // Accessible To is no longer collected — new resources default to All;
    // edits keep whatever the article already had stored.
    const userTypes =
      Array.isArray(value.articleViewableUserType) && value.articleViewableUserType.length > 0
        ? value.articleViewableUserType
        : ['All Users'];
    // FormData stringifies arrays comma-joined; keep that wire format explicitly.
    formData.append('articleViewableUserType', (userTypes[0] === 'All Users' ? ['All'] : userTypes).join(','));

    formData.append('isPublished', isPublished.toString());

    if (watchArticleType === 'Text' && textFile) {
      formData.append('file', textFile);
    }
    if (watchArticleType === 'Video') {
      if (videoFile) {
        formData.append('file', videoFile);
      }
    }
    if (watchArticleType === 'Video') {
      if (!videoFile) {
        setVideoError('Video file is required for Video type.');
        setAddEditSubmitLoader(false);
        return;
      }
    }
    if (watchArticleType === 'Audio') {
      if (audioFile) {
        formData.append('file', audioFile);
      }
    }
    if (watchArticleType === 'Audio') {
      if (!audioFile) {
        setAudioError('Audio file is required for Audio type.');
        setAddEditSubmitLoader(false);
        return;
      }
    }
    if (watchArticleType === 'Text') {
      if (!textFile && typeof value.fileUrl === 'string' && value.fileUrl) {
        const existingExtension = value.fileUrl.split('.').pop()?.toLowerCase() || '';
        if (ALLOWED_TEXT_FILE_EXTENSIONS.includes(existingExtension)) {
          formData.append('file', value.fileUrl);
        }
      }
    }
    // Keep an existing cover on edit; a create without one gets the org logo
    // as its cover image server-side.
    if (editCoverImg) {
      formData.append('coverImage', editCoverImg);
    }

    // A resource is org-wide (no program) when there is no group in context, or when the
    // "group" is actually the org parent group — the group-scoped create/edit/delete
    // endpoints reject the empty/parent group, so those use the dedicated org endpoints.
    // manualBuilderGroupId (= orgDetails.data.grpId) is the org parent group id.
    const candidateGroupId = newGroupId || (grpId && grpId !== 'admin' ? grpId : '');
    const isOrgLevelResource =
      !candidateGroupId ||
      (Boolean(manualBuilderGroupId) && candidateGroupId === manualBuilderGroupId) ||
      ((groupData?.data?.grpId === candidateGroupId || groupData?.data?._id === candidateGroupId) &&
        groupData?.data?.orgParentGroup === true);

    if (action === 'Add') {
      try {
        let usedOrgEndpoint = isOrgLevelResource;

        let response: any;
        try {
          response = usedOrgEndpoint
            ? await API.createOrgArticle({ data: formData, authId: orgId, location: resolvedLocation })
            : await API.createArticle({
                data: formData,
                orgId: orgId,
                groupId: candidateGroupId,
                helpSettings: false,
                location: resolvedLocation
              });
        } catch (err: any) {
          // Safety net: if client-side detection missed the org parent group, the backend
          // tells us explicitly — retry via the org endpoint rather than failing the save.
          if (
            !usedOrgEndpoint &&
            err?.response?.data?.message === "you can't create an Article for orgParentGroup"
          ) {
            usedOrgEndpoint = true;
            response = await API.createOrgArticle({ data: formData, authId: orgId, location: resolvedLocation });
          } else {
            throw err;
          }
        }
        const refetchGroupId = usedOrgEndpoint ? '' : candidateGroupId;

        if (response.status === 200 && response.data.message === 'Article Created Successfully') {
          setAddEditSubmitLoader(false);
          dispatch(articleActions.addArticle(response.data.createArticleResponse));

          // Only re-sync from the server for real program groups (getArticleList). For
          // an org-wide resource we rely on the optimistic addArticle above: the admin
          // list endpoint (getArticleList) filters on tags/publish state that a freshly
          // created org resource may not match, so a refetch could drop it or hide other
          // drafts. See note: org-level Resources listing needs a backend alignment.
          if (orgId && refetchGroupId) {
            dispatch(
              fetchAllArticles({
                orgId: orgId,
                groupId: refetchGroupId,
                helpSettings: false,
                useCache: false,
                location: resolvedLocation
              })
            );
          }
          console.log('new article response', response)
          clearAll();
          toast.success('Resource added.');
          setValue('articleName', '');
          reset();
          if (onNewArticleCreated) {
            onNewArticleCreated(response.data.createArticleResponse);
          }
          setOpenForm(false);
        } else if (
          response.status === 200 &&
          response.data.message === "You don't have permission to access this API"
        ) {
          toast.error("You don't have permission to add a resource");
          reset();
          setOpenForm(false);
        } else {
          console.error('Create article: unexpected response', response?.status, response?.data);
          throw new Error('Failed to create article');
        }
      } catch (error: any) {
        setAddEditSubmitLoader(false);
        console.error('Create article failed', error?.response?.status, error?.response?.data || error);
        toast.error('The resource could not be added. Try again.');
      }
    }

    if (action === 'Edit') {
      try {
        const editLocation = singleListData.location || localStorage.getItem('orgLocation') || 'us';
        const response = isOrgLevelResource
          ? await API.EditOrgArticle({
              authId: orgId,
              articleId: selectedActiveId,
              data: formData,
              location: editLocation
            })
          : await API.editArticle({
              data: formData,
              orgId: orgId,
              articleId: selectedActiveId,
              groupId: newGroupId || manualBuilderGroupId || resolvedGroupId,
              helpSettings: false,
              location: editLocation
            });
        if (response.status === 200) {
          setAddEditSubmitLoader(false);
          dispatch(articleActions.updateArticle(response.data.updatedArticle));
          if (orgId && resolvedGroupId) {
            dispatch(
              fetchAllArticles({
                orgId: orgId,
                groupId: manualBuilderGroupId || resolvedGroupId,
                helpSettings: false,
                useCache: false,
                location: resolvedLocation
              })
            );
          }
          toast.success('Resource updated.');
          setOpenForm(false);
          reset();
        }
      } catch (error) {
        setAddEditSubmitLoader(false);
        toast.error('The resource could not be saved. Try again.');
        console.log(error);
      }
    }

    reset();
    setValue('articleName', '');
    setValue('authorName', '');
    setValue('topic', '');
    setEditorState(EditorState.createWithContent(ContentState.createFromText('')));
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setIsPublished(checked);
  };

  const handleEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);

    const contentState = editorState.getCurrentContent();
    // const blockMap = contentState.getBlockMap();
    // let hasEmbeddedContent = false;
    let newContentState = contentState;

    // contentState.getBlockMap().forEach((block: any) => {
    //   const text = block.getText();
    //   // const urlRegex = /((https?:\/\/)?(www\.\S+\.(com|org|net|in|info|io)|\S+\.(com|org|net|in|info|io)))/g;
    //   const urlRegex = /(https?:\/\/)?(www\.\S+\.(com|org|net|in|info|io)|\S+\.(com|org|net|in|info|io))\S*/g;
    //   const matches = Array.from(text.matchAll(urlRegex));

    //   matches.forEach((match: any) => {
    //     const [url] = match;
    //     const start = match.index;
    //     const end = start + url.length;
    //     const existingEntityKey = block.getEntityAt(start);

    //     if (!existingEntityKey) {
    //       const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    //       const isImageURL = imageExtensions.some((extension) => url.endsWith(extension));

    //       const correctedUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
    //       const contentStateWithLink = newContentState.createEntity('LINK', 'MUTABLE', { url: correctedUrl });
    //       const linkEntityKey = contentStateWithLink.getLastCreatedEntityKey();
    //       newContentState = Modifier.applyEntity(
    //         newContentState,
    //         SelectionState.createEmpty(block.getKey()).merge({
    //           anchorOffset: start,
    //           focusOffset: end
    //         }),
    //         linkEntityKey
    //       );
    //     }
    //   });
    // });

    const newState = EditorState.push(editorState, newContentState, 'apply-entity');
    setEditorState(newState);

    const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    // console.log("htmlContent",htmlContent);
    setValue('articleDescription', htmlContent);
    clearErrors('articleDescription');
  };

  const insertImage = (editorState: EditorState, imageUrl: string, altImage: string) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', { src: imageUrl, alt: altImage });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');

    return newEditorState;
  };

  const handlePaste = useCallback(
    (event: ClipboardEvent) => {
      console.log('[AddEditContent] paste event', {
        types: Array.from(event.clipboardData?.types || []),
        items: Array.from(event.clipboardData?.items || []).map((item) => item.type)
      });
      const items = event.clipboardData?.items;
      if (!items) return;

      for (const item of items) {
        if (item.type.indexOf('image') === 0) {
          const file = item.getAsFile();
          if (file) {
            imageUpload(file, 400, 400, 0.5)
              .then((response: any) => {
                if (response.data.link) {
                  const imageUrl = response.data.link;
                  const altImage = 'image';
                  const width = '400px';
                  // Insert the uploaded image into the editor
                  const newEditorState = insertImage(editorState, imageUrl, altImage);
                  setEditorState(newEditorState);
                  // Prevent the default paste behavior
                  event.preventDefault();
                  return;
                }
              })
              .catch((error: any) => {
                console.error('Image upload error:', error);
              });
          }
        }
      }
    },
    [editorState]
  );


  useEffect(() => {
    const onPaste = (event: ClipboardEvent) => {
      const editorContainer = document.querySelector('.contentEditorClass');
      if (!editorContainer) return;
      const active = document.activeElement as HTMLElement | null;
      if (active && editorContainer.contains(active)) {
        handlePaste(event);
      }
    };

    document.addEventListener('paste', onPaste as any, true);
    return () => {
      document.removeEventListener('paste', onPaste as any, true);
    };
  }, [handlePaste]);

  const compressImage = (file: any, maxWidth: any, maxHeight: any, quality: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let { width } = img;
          let { height } = img;

          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }

          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob: any) => {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified
              });

              const compressedReader = new FileReader();
              compressedReader.onload = (compressedE: any) => {
                resolve(compressedE.target.result);
              };
              compressedReader.onerror = (error) => {
                reject(error);
              };
              compressedReader.readAsDataURL(compressedFile);
            },
            file.type,
            quality
          );
        };
        img.src = e.target.result;
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const readAsDataURL = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve({ data: { link: e.target.result } });
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const formData = new FormData();

  const uploadArticleDescriptionFile = async (file: File) => {
    formData.append('file', file);
    try {
      const result = await API.saveArticleDescriptionFiles(formData);
      const blobUrl = _.get(_.head(_.get(result, 'data.data')), 'Bloburl', '');
      return { data: { link: blobUrl } };
    } catch {
      return Error('Failed to upload');
    }
  };

  const imageUpload = async (file: any, maxWidth: any = 400, maxHeight: any = 400, quality: any = 1.0) => {
    if (!acceptedImages.includes(file.type)) {
      return { error: 'Image upload failed' };
    } else {
      try {
        // if (file.size <= 1024 * 1024) {
        //   return await readAsDataURL(file);
        // }
        // const imageDataUrl = await handleImageCompression(file)
        // return await readAsDataURL(imageDataUrl)
        // const imageDataUrl = await compressImage(file, maxWidth, maxHeight, quality);

        if (file.size <= 1024 * 1024) {
          const result = await uploadArticleDescriptionFile(file);
          return result;
        } else {
          const reSizedFile = await handleImageCompression(file);
          if (reSizedFile) {
            const result = await uploadArticleDescriptionFile(reSizedFile);
            return result;
          }
        }
      } catch (error) {
        console.error('Image upload error:', error);
        return { error: 'Image upload failed' };
      }
    }
  };

  const blockRender = (contentBlock: any) => {
    const entityKey = contentBlock.getEntityAt(0);
    const contentState = editorState.getCurrentContent();

    if (contentBlock.getType() === 'atomic' || contentBlock.text === '📷') {
      return {
        component: ImageBlock,
        editable: false,
        props: {
          block: contentBlock,
          // contentState,
          blockProps: {
            editorState,
            setEditorState
          }
        }
      };
    }
    return null;
  };

  // const imageUpload = (file: any) => {

  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       resolve({ data: { link: e.target.result } });
  //     };
  //     reader.onerror = (e) => {
  //       reject(e);
  //     };
  //     reader.readAsDataURL(file);
  //   });
  // };

  useEffect(() => {
    if (singleListData && action === 'Edit') {
      console.log(singleListData)
      for (const field in singleListData) {
        setValue(field, singleListData[field]);
      }
      const { articleDescription, isPublished, coverImageUrl, fileUrl } = singleListData;
      console.log({ articleDescription, isPublished, coverImageUrl, fileUrl })
      setUrlName(fileUrl);
      if (/\.(mp4|webm|ogg|ogv)$/i.test(fileUrl)) {
        setVideoFile(fileUrl);
        setEditVideoUrl(fileUrl);
      }
      if (/\.(mp3|wav|ogg)$/i.test(fileUrl)) {
        setAudioFile(fileUrl);
        setEditAudioUrl(fileUrl);
      }
      if (_.get(singleListData, 'type') === 'Text') {
        setTextFileUrl(fileUrl);
      }
      setValue('articleDescription', articleDescription);
      setValue('coverImg', coverImageUrl);
      setIsPublished(isPublished);
      setEditCoverImg(coverImageUrl);
      const editorState = safeEditorStateFromHtml(articleDescription);
      setEditorState(editorState);
    }
  }, [singleListData, action]);

  const embedCallback = (url: any) => {
    if (url.indexOf('youtube') >= 0) {
      url = url.replace('watch?v=', 'embed/');
      url = url.replace('/watch/', '/embed/');
      url = url.replace('youtu.be/', 'youtube.com/embed/');
    }
    return url; // Return the modified URL or the original URL
  };

  const clearAll = () => {
    setVideoFile(null);
    reset();
    setType('Text');
    setValue('type', 'Text');
    setEditCoverImg('');
    setEditorState(EditorState.createWithContent(ContentState.createFromText('')));
    setEditVideoUrl(null);
    setAudioFile(null);
    setEditAudioUrl(null);
    setTextFileUrl(null);
    setTextFile(null);
  };
  useEffect(() => {
    if (action === 'Add' && openForm) {
      clearAll();
    }
  }, [action, openForm]);

  useEffect(() => {
    clearAll();
    setValue('type', 'Text');
    setValue('readTime', '');
    // setValue('accessFor', '');
  }, []);

  const handleRemoveTextFileUrl = () => {
    setTextFile(null);
    setTextFileUrl(null);
  };

  return (
    <Dialog
      className="add-edit-content-dialog"
      open={openForm}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEnforceFocus
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          bgcolor: '#0F0F0F',
          color: '#FDFDFD',
          border: '1px solid #444444',
          borderRadius: 2,
          overflow: 'visible'
        }
      }}
    >
      <CommonModalHeader
        title={action === 'Edit' ? 'Edit Resource' : 'Add Resource'}
        handleCloseModal={handleClickCloseForm}
      />
      <DialogContent sx={{ p: 3, overflowX: 'visible' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box display="flex" alignItems="center" gap="10px">
            <UiSwitch checked={isPublished} onChange={handleSwitchChange} />
            <Typography sx={{ color: '#FDFDFD', fontSize: 14 }}>Visible to others</Typography>
          </Box>

          <Controller
            name="articleName"
            control={control}
            render={({ field: { onChange, value } }) => (
              <DosenInput
                label="Resource Name *"
                name="articleName"
                value={value || ''}
                id="helpArticleName"
                type="text"
                placeholder="Resource name"
                onChange={onChange}
                error={checkError('articleName')}
                helperText={getError('articleName')?.toString()}
              />
            )}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Controller
                name="type"
                control={control}
                rules={{ required: true }}
                defaultValue={type}
                render={({ field }) => (
                  <UiSelect
                    label="Resource Type *"
                    placeholder="Select"
                    value={field.value || ''}
                    onChange={(event) => {
                      field.onChange(event);
                    }}
                    // File uploads were removed, so new Audio/Video articles can't be
                    // created any more — media goes in the description (embed/upload
                    // toolbar). Existing Audio/Video articles keep their type on edit.
                    options={
                      action === 'Edit'
                        ? [
                            { label: 'Text', value: 'Text' },
                            { label: 'Audio', value: 'Audio' },
                            { label: 'Video', value: 'Video' }
                          ]
                        : [{ label: 'Text', value: 'Text' }]
                    }
                    errorText={getError('type')?.toString()}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="readTime"
                control={control}
                defaultValue={readTimeValue}
                render={({ field }) => (
                  <UiSelect
                    label="Read Time *"
                    placeholder="Select"
                    value={field.value || ''}
                    onChange={(event) => field.onChange(event)}
                    options={[
                      { label: '1 Min', value: '1 Min' },
                      { label: '2 Min', value: '2 Min' },
                      { label: '3 Min', value: '3 Min' },
                      { label: '4 Min', value: '4 Min' },
                      { label: '5 Min', value: '5 Min' },
                      { label: '10 Min', value: '10 Min' },
                      { label: '15 Min', value: '15 Min' },
                      { label: '15+ Min', value: '15+ Min' }
                    ]}
                    errorText={getError('readTime')?.toString()}
                  />
                )}
              />
            </Grid>
          </Grid>

        {/* File dropzones removed — existing files still preview below; new
            resources carry their content in the description. */}
        {watchArticleType === 'Video' && (videoFile || editVideoUrl) && (
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ borderRadius: '8px 8px 8px 8px' }}>
                {videoFile && videoFile.type && videoFile.type.startsWith('video/') && (
                  <video
                    style={{ borderRadius: '8px 8px 8px 8px' }}
                    src={URL.createObjectURL(videoFile)}
                    width="320"
                    height="240"
                    controls
                  />
                )}
                {editVideoUrl && (
                  <video
                    style={{ borderRadius: '8px 8px 8px 8px' }}
                    src={
                      editVideoUrl
                        ? typeof editVideoUrl === 'string'
                          ? editVideoUrl
                          : URL.createObjectURL(editVideoUrl)
                        : undefined
                    }
                    width="320"
                    height="240"
                    controls
                  />
                )}
              </div>
            </div>
            {videoError && <FormHelperText error>{videoError}</FormHelperText>}
          </div>
        )}
        {watchArticleType === 'Audio' && (audioFile || editAudioUrl) && (
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ borderRadius: '8px' }}>
                {audioFile?.type?.startsWith('audio/') && (
                  <audio style={{ borderRadius: '8px' }} src={audioFile && URL.createObjectURL(audioFile)} controls>
                    Your browser does not support the audio element.
                  </audio>
                )}

                {editAudioUrl && (
                  <>
                    <audio
                      style={{ borderRadius: '8px' }}
                      src={
                        editAudioUrl
                          ? typeof editAudioUrl === 'string'
                            ? editAudioUrl
                            : URL.createObjectURL(editAudioUrl)
                          : undefined
                      }
                      controls
                    />
                    <p>{editAudioUrl.name}</p>
                  </>
                )}
              </div>
            </div>
            {audioError && <FormHelperText error>{audioError}</FormHelperText>}
          </div>
        )}

        {watchArticleType === 'Text' && (
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ borderRadius: '8px' }}>{textFileUrl && <p>{textFileUrl?.name}</p>}</div>
              {(textFile || textFileUrl) && (
                <div
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#FDFDFD',
                    marginTop: '10px',
                    marginBottom: '10px',
                    margin: 'auto',
                    marginLeft: '1%'
                  }}
                >
                  <span
                    onClick={() =>
                      textFileUrl?.includes('http')
                        ? window.open(textFileUrl, '_blank')
                        : blobTextFileUrl
                        ? window.open(blobTextFileUrl, '_blank')
                        : null
                    }
                    style={{
                      color: '#FDFDFD',
                      textDecorationLine: 'underline',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6
                    }}
                  >
                    <FileOutlined /> {watchArticleType === 'Text' ? (textFile?.name ? textFile.name : filename) : ''}
                  </span>
                  <IconButton onClick={handleRemoveTextFileUrl}>
                    <Close fontSize="small" color="error" />
                  </IconButton>
                </div>
              )}
            </div>
            {textFileError && <FormHelperText error>{textFileError}</FormHelperText>}
          </div>
        )}
        <Grid container spacing={2}>
          {/* Author Name removed — resources are authored by the org (default applied on save). */}
          {/* <Grid item md={6}>
            <InputLabel>
              Who can view *
            </InputLabel>

            <FormControl fullWidth variant="outlined">
              <Controller
                name="accessFor"
                control={control}
                defaultValue={viewFor}
                render={({ field }) => (
                  <Select
                    id="accessFor"
                    placeholder="Select"
                    {...field}
                    error={!!errors.accessFor}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span
                            style={{
                              fontFamily: 'Inter',
                              fontSize: '14px',
                              fontWeight: '400',
                              color: '#DCE0E4'
                            }}
                          >
                            Who can view
                          </span>
                        );
                      }
                      return selected;
                    }}
                  >
                    <MenuItem value="Public">Public</MenuItem>
                    <MenuItem value="Private">Private</MenuItem>
                  </Select>
                )}
              />
              <FormHelperText error>{getError('accessFor')?.toString()}</FormHelperText>
            </FormControl>
          </Grid> */}
          <Grid item md={6}>
            <Controller
              name="articleViewableTo"
              control={control}
              defaultValue={''}
              render={({ field }) => (
                <UiSelect
                  label="Resource Viewable To *"
                  placeholder="Select"
                  value={getValues('articleViewableTo') || field.value || ''}
                  onChange={(event) => field.onChange(event)}
                  options={[
                    { label: 'All of Dosen', value: 'All of Dosen' },
                    { label: 'Organization-wide', value: 'Organization-wide' },
                    { label: 'Program only', value: 'Program only' }
                  ]}
                  errorText={getError('articleViewableTo')?.toString()}
                />
              )}
            />
          </Grid>
          {/* Article Accessible To removed — new resources default to All members. */}
          {/* Topics and Industry hidden — hardcoded as "Topic Creation" / "Industry Creation" in payload */}
          {/* <Grid item md={12}>
            <InputLabel>Topic</InputLabel>
            <FormControl fullWidth>
              <Controller
                name="topic"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="helpTopic"
                    size="small"
                    // Remove 'multiple' prop to disallow multiple selections
                    value={field.value || null} // Update value prop to be a single value or null
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setValue('topic', newValue);
                        setError('topic', { message: undefined });
                      } else {
                        setValue('topic', '');
                        setError('topic', { message: 'Select a topic' });
                      }
                    }}
                    filterOptions={(options, params) => {
                      if (!Array.isArray(options)) {
                        options = [];
                      }
                      const filtered = options?.filter(
                        (option) =>
                          typeof option === 'string' &&
                          option.toLowerCase().indexOf(params.inputValue.toLowerCase()) !== -1
                      );

                      if (params.inputValue !== '') {
                        filtered.push(`${params.inputValue}`);
                      }

                      return filtered;
                    }}
                    options={TagList || []}
                    getOptionLabel={(option) => option}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select"
                        error={getError('topic')?.toString() ? checkError('topic') : false}
                      />
                    )}
                  />
                )}
              />
              <FormHelperText error>{getError('topic')?.toString()}</FormHelperText>
            </FormControl>
          </Grid> */}
          <Grid item md={12}>
            <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5 }}>Resource Description *</Box>
            <Box
              style={{
                width: '100%'
              }}
              onPasteCapture={(event) => {
                console.log('[AddEditContent] onPasteCapture', {
                  types: Array.from((event as any).clipboardData?.types || []),
                  items: Array.from((event as any).clipboardData?.items || []).map((item: any) => item.type)
                });
                handlePaste(event as any);
              }}
            >
              <Controller
                name="articleDescription"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <>
                    <Editor
                      editorStyle={{
                        margin: '0px',
                        paddingLeft: '3px',
                        fontFamily: 'Inter, sans-serif',
                        background: 'rgba(0,0,0,0.7)',
                        color: '#FDFDFD',
                        minHeight: '120px'
                      }}
                      wrapperStyle={{
                        padding: 0,
                        border: '1px solid #868686',
                        borderRadius: '6px'
                      }}
                      toolbarStyle={{
                        ...toolBarStyle,
                        backgroundColor: '#1C1C1C',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                      }}
                      toolbar={{
                        image: {
                          popupClassName: 'articleImage-modal',
                          inputAccept: acceptedImages,
                          uploadCallback: imageUpload,
                          previewImage: true
                        },
                        embedded: {
                          embedCallback: embedCallback
                        }
                      }}
                      customBlockRenderFunc={blockRender}
                      editorClassName="editorSize contentEditorClass"
                      editorState={editorState}
                      onEditorStateChange={handleEditorStateChange}
                      placeholder="Write your resource description here"
                      toolbarClassName="toolbar-class custom-modal toolBarStyleDark"
                      wrapperClassName="wrapperClassName wrapper-class custom-header-dropdown"
                    />

                    <FormHelperText error> {getError('articleDescription')?.toString()}</FormHelperText>
                  </>
                )}
              />
            </Box>
          </Grid>
        </Grid>
        {/* Form Code End */}
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '15px 20px', justifyContent: 'center' }}>
        <DosenButton
          sx={{
            fontSize: '16px',
            fontWeight: 700,
            borderRadius: '8px',
            width: '560px',
            height: '50px'
          }}
          loading={addEditSubmitLoader}
          loadingText={action === 'Edit' ? 'Saving...' : 'Adding...'}
          onClick={handleSubmit(onSubmit)}
        >
          {action === 'Edit' ? 'Save' : 'Add Resource'}
        </DosenButton>{' '}
      </DialogActions>
    </Dialog>
  );
};

export default AddEditContent;
